var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUsersLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_802_377)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 10.5C10.9889 10.5 11.9556 10.2068 12.7779 9.65735C13.6001 9.10794 14.241 8.32705 14.6194 7.41342C14.9978 6.49979 15.0969 5.49446 14.9039 4.52455C14.711 3.55465 14.2348 2.66373 13.5355 1.96447C12.8363 1.26521 11.9454 0.789002 10.9755 0.596076C10.0055 0.40315 9.00021 0.502166 8.08658 0.880605C7.17295 1.25904 6.39206 1.89991 5.84265 2.72215C5.29324 3.5444 5 4.5111 5 5.5C5.00132 6.82568 5.52853 8.09668 6.46593 9.03407C7.40332 9.97147 8.67432 10.4987 10 10.5ZM10 2.16667C10.6593 2.16667 11.3037 2.36217 11.8519 2.72844C12.4001 3.09471 12.8273 3.6153 13.0796 4.22439C13.3319 4.83348 13.3979 5.5037 13.2693 6.1503C13.1407 6.79691 12.8232 7.39085 12.357 7.85703C11.8908 8.3232 11.2969 8.64067 10.6503 8.76929C10.0037 8.8979 9.33347 8.83189 8.72439 8.5796C8.1153 8.32731 7.59471 7.90007 7.22843 7.3519C6.86216 6.80374 6.66667 6.15927 6.66667 5.5C6.66667 4.61595 7.01786 3.7681 7.64298 3.14298C8.2681 2.51786 9.11594 2.16667 10 2.16667Z",
    fill: "#3E40B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 12.167C8.01155 12.1692 6.10518 12.9601 4.69914 14.3661C3.29309 15.7722 2.50221 17.6785 2.5 19.667C2.5 19.888 2.5878 20.1 2.74408 20.2562C2.90036 20.4125 3.11232 20.5003 3.33333 20.5003C3.55435 20.5003 3.76631 20.4125 3.92259 20.2562C4.07887 20.1 4.16667 19.888 4.16667 19.667C4.16667 18.1199 4.78125 16.6362 5.87521 15.5422C6.96917 14.4482 8.4529 13.8337 10 13.8337C11.5471 13.8337 13.0308 14.4482 14.1248 15.5422C15.2188 16.6362 15.8333 18.1199 15.8333 19.667C15.8333 19.888 15.9211 20.1 16.0774 20.2562C16.2337 20.4125 16.4457 20.5003 16.6667 20.5003C16.8877 20.5003 17.0996 20.4125 17.2559 20.2562C17.4122 20.1 17.5 19.888 17.5 19.667C17.4978 17.6785 16.7069 15.7722 15.3009 14.3661C13.8948 12.9601 11.9884 12.1692 10 12.167V12.167Z",
    fill: "#3E40B7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_802_377"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersLogo);
export default __webpack_public_path__ + "static/media/usersLogo.78fdad385c4a1aa71ae2d8dbd560607a.svg";
export { ForwardRef as ReactComponent };